export default __webpack_public_path__ + "static/media/step_02_active.0b27918a.svg";